import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.Scroller {
  width: 100%;
  max-width: 1920px;
  overflow-y: hidden;
  /* leave space for hover states to get bigger without affecting whitespace */
  padding-top: 12px;
  -webkit-overflow-scrolling: touch;
  -webkit-perspective: 1000;
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
}

.Scroller::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
  height: 0px;
}
.RecommendedProgramme {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 100%;
  gap: 8px;
}

section.recommended {
  margin-bottom: 0px !important;
  margin-left: 0px !important;
}

.prog-ellipse {
  vertical-align: middle;
}
.ad-container {
  position: relative;
  margin-right: 16px;
  width: 300px;
  top: 0px;
}

.no-adslot{
  top: 0px;
  width: 10px;
}

.poster-container {
  position: relative;
  width: 264px;
  margin-right: 16px;
  top: 0px;
}
.ad-label::before{
  content: "Ad";
  position: absolute;
  height: 29px;
  top: 18px;
  right: 10px;
  width: 50px;
  border-radius: 4px;
  text-align: center;
  background: #FFB942;
  padding: 0px;
  color: white;
  align-content: center;
  font-size: 16px;
  font-weight: 400;
}

.scroll {
  /*
   * inline-flex is needed so that row is padded
   * within its .scroll parent
   */
  min-width: 100%;
  display: inline-flex;
  align-items: stretch;
  transition: 400ms transform ease-in-out;
  margin: 0;
  padding: 0;
  will-change: transform;
}

@-webkit-keyframes fadeInUp {
  100% { opacity: 1; }
  0% { opacity: 0; }
}

@keyframes fadeInUp{
  0%{
  opacity: 0;
  }
  100%{
      opacity:1;
  }
}

.scroll.no-transition {
  transition: none;
}

:global(.scroller-wrapper) {
  overflow: hidden;
  /* margin-left: -16px; */
}


@media (min-width: 768px) {
  .RecommendedProgramme {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
  }

  .card {
    flex-basis: calc((100% - 32px) / 5);
    flex-grow: 0;
    max-width: calc(50% - 16px);
    margin: 0 8px;
  }

  .card:hover {
      border: 2px solid rgba(246, 246, 246, 0.5);
      box-shadow: 0px 0px 9px #fff;
      transform: none !important;
      border-radius: 8px;
      background: linear-gradient(180deg, rgba(21, 21, 21, 0) 75%, rgba(21, 21, 21, 0.85) 100%);
  }

  .card:nth-of-type(3n + 1) {
    margin-left: 0;
  }

  .card:nth-of-type(3n + 3) {
    margin-right: 0;
  }
}
`

export const paginationStyles = css`
.scroller-controls {
  position: relative;
  z-index: 1;
  transition: 300ms opacity ease-in-out;
}

.scroller-controls .pagination-nav {
  opacity: 1;
}

.scroller-controls.special-event .pagination-nav {
  display: none;
}

ul:not(.special-event) {
  padding: 0;
  text-align: right;
  margin-right: 52px;
  margin-bottom: 0;
}

.scroller-controls.special-event {
  position: absolute;
  right: 3%;
  bottom:41%;
}

.scroller-controls.special-event ul.special-event {
  opacity: 1;
}

.has-title {
  margin-top: -20px;
}

li {
  display: inline-block;
}

ul.special-event li:first-child,
ul.special-event li:last-child {
  display: none;
}

ul.special-event {
  height: 6px;
  display: flex;
  justify-content: center !important;
  text-align: center;
  padding: 0;
  margin-block-start: 5px;
  margin-block-end: 0;
  padding-right: 18px;
  bottom: 80px;
}


button {
  -webkit-appearance: none;
  border-radius: 0;
  border: 0;
  box-shadow: none;
  cursor: pointer;
}

.pagination-button {
  width: 16px;
  height: 2px;
  text-indent: -9999px;
  background-color: ${colors.lightGrey2};
  transition: 200ms background-color;
  margin-left: 2px;
}

ul.special-event li {
  padding: 0;
  height: 6px;
}

ul.special-event li button.pagination-button{
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-left: 7px;
  padding: 4px;
}

.pagination-button:focus {
  outline: 0;
}

.pagination-button:not(.special-event):hover, .pagination-button:focus {
  background-color: ${colors.midGrey2};
}

.pagination-button.active {
  background-color: ${colors.darkGrey};
}

.pagination-button.special-event {
  background-color: ${colors.textInput};
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
}

.pagination-button.special-event.active {
  background-color: ${colors.primaryText};
}

.pagination-nav {
  height: 20vw;
  width: 40px;
  position: absolute;
  top: calc(100% + 8px);
  transition-property: background-color, opacity;
  transition-duration: 100ms;
  opacity: 1;
}

.pagination-nav:focus {

}

.pagination-nav[disabled] {
  display: none;
}

.next {
  right: 0;
  background: linear-gradient(to left, #151515 0%, rgba(21, 21, 21, 0) 50%);
}

.next:hover {
  background: linear-gradient(to left, #151515 11.46%, rgba(21, 21, 21, 0) 100%);
}

.prev {
  left: -15px;
  background: linear-gradient(to right, #151515 0%, rgba(21, 21, 21, 0) 50%);
}

.prev:hover{
  background: linear-gradient(to right, #151515 11.46%, rgba(21, 21, 21, 0) 100%);
}
.button-text {
  position: absolute;
  text-indent: -9999px;
}

.icon-wrapper {
  transform: none;
}

@media (min-width: 1024px) {
  .pagination-nav {
    width: 44px;
  }
}
@media (max-width:767px){
  ul.special-event {
    padding-right: 0px;
  }
  }
`
